import type { LayoutArea, LayoutFamily, ThemeLayout } from '@/features/storefront/themeSchema';
import { THEME_IDS, THEME_TOKENS, themeTokens, type ThemeTokens } from '@/previewThemes/meta';

/**
 * Which theme one page area actually renders.
 *
 * `'family'` is the common case - the area follows the theme the document
 * names - and an explicit value is a merchant's deliberate mix, say the
 * editorial look with a classic header. Kept as one function so "what does
 * this area look like" has exactly one answer everywhere.
 */
export function resolveVariant(layout: ThemeLayout, area: LayoutArea): LayoutFamily {
  const variant = layout[area];
  return variant === 'family' ? layout.family : variant;
}

/**
 * The storefront's view of the theme registry.
 *
 * These are re-exports rather than definitions: a theme's design constants
 * live in `previewThemes/<id>/meta.ts`, and this module is the storefront's
 * stable name for them. It deliberately reaches for the *component-free* half
 * of the registry - `theme.ts` turns these tokens into CSS custom properties,
 * and a theme's own components import that, so reading them from a module with
 * markup in it would close the circle.
 */
export type FamilyTokens = ThemeTokens;
export const FAMILY_TOKENS = THEME_TOKENS;
export const LAYOUT_FAMILIES = THEME_IDS;

/** One theme's tokens, falling back to the base theme's. */
export const familyTokens = themeTokens;
